import React, { useEffect, useState } from "react";

function normalizeOne(payload) {
  if (Array.isArray(payload)) return payload[0] ?? null;
  if (payload && Array.isArray(payload.data)) return payload.data[0] ?? null;
  if (payload && typeof payload.data === "object") return payload.data;
  if (payload && typeof payload === "object") return payload;
  return null;
}

const API_BASE = "https://hcserver.dplanit.co.kr";

export default function App() {
  const [imgUrl, setImgUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  // 실제 뷰포트 px을 --vh에 넣어서 모바일 주소창 변화 대응
  useEffect(() => {
    const setVH = () =>
      document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);
    setVH();
    window.addEventListener("resize", setVH);
    window.addEventListener("orientationchange", setVH);
    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  // 전역 스크롤 완전 차단
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overflow;
    const prevBody = body.style.overflow;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    return () => {
      html.style.overflow = prevHtml;
      body.style.overflow = prevBody;
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/v1/items`, { headers: { Accept: "application/json" } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const one = normalizeOne(json);
        const url = one?.image_img || one?.banner_url || "";
        if (!url) throw new Error("이미지 URL이 없습니다.");
        setImgUrl(url);
      } catch (e) {
        setErr(e?.message ?? "불러오기에 실패했습니다.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      {/* margin 0 + safe-area + viewport-fit */}
      <style>{`
        html, body, #root { margin: 0; height: 100%; }
        body { overscroll-behavior: none; }
        :root{
          --safe-top: env(safe-area-inset-top, 0px);
          --safe-bottom: env(safe-area-inset-bottom, 0px);
          --safe-left: env(safe-area-inset-left, 0px);
          --safe-right: env(safe-area-inset-right, 0px);
        }
      `}</style>

      {/* 화면 전체 "영역" (스크롤 없음) */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          paddingTop: "var(--safe-top)",
          paddingBottom: "var(--safe-bottom)",
          paddingLeft: "var(--safe-left)",
          paddingRight: "var(--safe-right)",
          backgroundColor: "#000",           // 여백은 검은 배경
          overflow: "hidden",
        }}
      >
        {/* 배경 블러(선택): 꽉 찬 느낌 */}
        {imgUrl && (
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${imgUrl})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
              filter: "blur(20px)",
              transform: "scale(1.1)",
              opacity: 0.6,
              pointerEvents: "none",
            }}
          />
        )}

        {/* ✅ 내부 박스: 뷰포트에 정확히 맞춘 캔버스 */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            width: "100vw",
            height: "var(--vh, 100svh)", // 실제 뷰포트 높이
            // 여기서 이미지를 'contain'으로 넣으면 절대 안 잘림
            backgroundImage: imgUrl ? `url(${imgUrl})` : "none",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
        >
          {loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "grid",
                placeItems: "center",
                color: "#fff",
                fontSize: 14,
                opacity: 0.8,
              }}
            >
              로딩 중...
            </div>
          )}
          {err && !loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "grid",
                placeItems: "center",
                color: "#fff",
                fontSize: 14,
              }}
            >
              {err}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
